import View from './View';

export { default as View, getPickerButtonStyles } from './View';

export default View;
